export default __webpack_public_path__ + "d34d4ad4ee40a0dc5e64d52bfe1f053b.pdf";